import { defineComponent as _defineComponent } from 'vue'
import VTextField from "@busy-human/vue-component-library/components/text-field.vue"
import useClickOutside from '../composables/useClickOutside'
import { PaymentMethods } from '@busy-human/opt-library'
import { ref } from 'vue';

type Props = {
    payment: PaymentMethods.Model
}
type Emits = {
    (e: 'delete'): void
}

export default /*#__PURE__*/_defineComponent({
  __name: 'payment-method',
  props: {
    payment: null
  },
  emits: ["delete"],
  setup(__props: any, { expose, emit }: { emit: ({
    (e: 'delete'): void
}), expose: any, slots: any, attrs: any }) {
  expose();

const props = __props as {
    payment: PaymentMethods.Model
}





const paymentMethodContainer = ref()

useClickOutside(paymentMethodContainer, ()=> {
    showActions.value = false
})

const showActions = ref(false)

const handleEdit = () => {
    //TODO: Handle The Edit Function
}

const handleDelete = () => {
    //TODO: Emit delete and handle it in payment-select-window
}


const __returned__ = { props, emit, paymentMethodContainer, showActions, handleEdit, handleDelete, VTextField, useClickOutside, PaymentMethods, ref }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})